var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i_status_footer"},[_c('div',{staticClass:"save_btn one_btn",on:{"click":function($event){return _vm.save('nosale')}}},[_vm._v(_vm._s(_vm.$t('save')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }